/**
 * @generated SignedSource<<9efc1bd6ce6b7a4c590f0df2f9dc7061>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type libraryImportTaskQueriesImportDefaultMutation$variables = Record<PropertyKey, never>;
export type libraryImportTaskQueriesImportDefaultMutation$data = {
  readonly importDefaultLibrary: ReadonlyArray<{
    readonly importedImages: number;
    readonly lastError: string;
    readonly packageIDs: string;
    readonly progressPercent: number;
    readonly state: number;
    readonly stateName: string;
    readonly taskID: number;
    readonly totalImages: number | null;
    readonly triggerType: number;
  }>;
};
export type libraryImportTaskQueriesImportDefaultMutation = {
  response: libraryImportTaskQueriesImportDefaultMutation$data;
  variables: libraryImportTaskQueriesImportDefaultMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LibraryImportTask",
    "kind": "LinkedField",
    "name": "importDefaultLibrary",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "triggerType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "packageIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "importedImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "progressPercent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastError",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "libraryImportTaskQueriesImportDefaultMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "libraryImportTaskQueriesImportDefaultMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "b11e7df1147ffa10afb2d18efbc7748e",
    "id": null,
    "metadata": {},
    "name": "libraryImportTaskQueriesImportDefaultMutation",
    "operationKind": "mutation",
    "text": "mutation libraryImportTaskQueriesImportDefaultMutation {\n  importDefaultLibrary {\n    taskID\n    state\n    stateName\n    triggerType\n    packageIDs\n    totalImages\n    importedImages\n    progressPercent\n    lastError\n  }\n}\n"
  }
};
})();

(node as any).hash = "f29be5f2639c451f701fcce537b4582e";

export default node;
